import workspaceQuery from '../../../graphql/queries/customer/CustomerPriceSourceWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/customer/CustomerPriceSourceListQuery.graphql';
import instanceQuery from '../../../graphql/queries/customer/CustomerPriceSourceQuery.graphql';
import defaultQuery from '../../../graphql/queries/customer/CustomerPriceSourceDefault.graphql';
import mutationQuery from '../../../graphql/mutations/customer/CustomerPriceSourceMutation.graphql';
import fragment from '../../../graphql/fragments/customer/CustomerPriceSourceFragment.graphql';
import { Direction } from '../../schema/p4types';

const CustomerPriceSource = {
  type: 'CustomerPriceSource',
  title: 'Customer Price Sources',
  formTitle: 'Customer Price Source',
  formUrl: '/Customers/PriceSource/Details/',
  workspaceUrl: '/Sales/CustomerPricing/CustomerPriceSource/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
    remoteFilter: true,
    preLoad: true,
    customVariables: () => {
      return {
        orderBy: 'name',
        orderDirection: Direction.Asc,
        first: 50,
      };
    },
  },
  fragment,
  screenReference: 'CUSTOMER_PRICE_SOURCE',
};

export default CustomerPriceSource;
